export default {
  projectTitle: 'Votre projet',
  projectTitleMinor: 'Le projet pour votre enfant',

  projectObjective: 'Vous avez pour projet {objective}.',
  projectObjectiveMinor: 'Vous avez pour projet pour votre enfant {objective}.',

  objectives: {
    growWealth: 'de développer votre patrimoine',
    increaseCapital: 'de valoriser un capital',
    preserveCapital: 'de préserver un capital',
    generateAdditionalIncome: 'd’obtenir des revenus complémentaires',
    diversifyWithTaxAdvantages:
      'de diversifier votre patrimoine en optant pour des dispositifs avec une fiscalité avantageuse',
    prepareRetirement: 'de préparer votre retraite',
    prepareTransmission: 'de préparer votre transmission',
    improveInsuranceCoverage: 'd’améliorer votre prévoyance',
    prepareChildFuture:
      'de préparer son avenir (études, permis de conduire, première installation...)',
    receiveRegularIncome: 'de percevoir des revenus réguliers',
    diversifyChildWealth: 'de diversifier son patrimoine',
    makeAnInvestment: 'de faire un placement',
    remunerateTreasury: 'de rémunérer la trésorerie de l’entreprise',
    increaseProPatrimony: 'de valoriser le patrimoine financier de l’entreprise',
    searchAdditionalIncome: 'de recherche des revenus complémentaires',
  },

  proTreasuryInvestment:
    'Vous nous avez indiqué avoir prévu, par ailleurs, des investissements ou des dépenses significatives susceptibles d’affecter la trésorerie de l’entreprise durant l’exercice fiscal en cours pour un montant de {amount}.',
  proNoTreasuryInvestment:
    'Vous nous avez indiqué ne pas avoir prévu, par ailleurs, des investissements ou des dépenses significatives susceptibles d’affecter la trésorerie de l’entreprise durant l’exercice fiscal en cours.',

  allocationBoth:
    'Dans le cadre de ce projet, vous envisagez d’allouer {initialAmount} et un effort d’épargne mensuel de {monthlyAmount}.',
  allocationInitialOnly:
    'Dans le cadre de ce projet, vous envisagez d’allouer {initialAmount}.',
  allocationMonthlyOnly:
    'Dans le cadre de ce projet, vous envisagez de consacrer un effort d’épargne mensuel de {monthlyAmount}.',
  allocationArbitrageOnly:
    'Dans le cadre de ce projet, vous envisagez de réaliser des arbitrages sur vos avoirs existants.',

  precautionarySavingsWarning:
    'Nous vous avons alerté qu’en allouant ce montant pour votre projet, votre épargne disponible sera de {availableSavings} après investissement, montant inférieur à l’épargne de précaution recommandée de {precautionarySavings} dans votre situation.',
}
